import { Box, InputAdornment } from "@mui/material";
import { Controller, ControllerRenderProps } from "react-hook-form";

import { TextField } from "@/components/ui-v2";

interface DimensionFieldProps {
  fieldName: string;
  label: string;
  onSizeChange: (value: string, field: ControllerRenderProps) => void;
}

export const DimensionField = (props: DimensionFieldProps) => {
  const { fieldName, label, onSizeChange } = props;

  return (
    <Controller
      name={fieldName}
      render={({ field, fieldState: { error } }) => (
        <Box sx={{ pt: 6 }}>
          <TextField
            {...field}
            error={!!error}
            fullWidth
            helperText={error?.message}
            label={label}
            onChange={(event) => onSizeChange(event.target.value, field)}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">px</InputAdornment>
                ),
              },
              inputLabel: {
                shrink: true,
              },
            }}
            type="number"
            value={field.value ?? ""}
          />
        </Box>
      )}
    />
  );
};
